import { NudosGenericModal, NudosModalContent } from 'components/NudosComponents';
import { PurcharseOrderConfirmationModalContent } from './PurcharseOrderConfirmationModalContent';

interface IPurchaseOrderConfirmationModal {
  handleCloseAcceptConfirmationModal: () => void;
  handleAcceptUpdatePurchaseOrder: () => Promise<void>;
}

export const PurcharseOrderConfirmationModal = ({
  handleCloseAcceptConfirmationModal,
  handleAcceptUpdatePurchaseOrder
}: IPurchaseOrderConfirmationModal) => {
  return (
    <NudosGenericModal
      clickOutsideCallback={handleCloseAcceptConfirmationModal}
      closeModalCallback={handleCloseAcceptConfirmationModal}
      modalContent={
        <NudosModalContent
          toCloseModal={handleCloseAcceptConfirmationModal}
          customWidth="480px"
          customHeight="250px"
          excludeHeader
          CustomModalComponent={
            <PurcharseOrderConfirmationModalContent
              handleCloseAcceptConfirmationModal={handleCloseAcceptConfirmationModal}
              handleAcceptUpdatePurchaseOrder={handleAcceptUpdatePurchaseOrder}
            />
          }
        />
      }
    />
  );
};
